// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_dy-b";
export var colorBlue = "_dy-8";
export var colorDot = "_dy-0";
export var colorDotLarge = "_dy-2";
export var colorDotSmall = "_dy-1";
export var colorGreen = "_dy-7";
export var colorGrey = "_dy-3";
export var colorOrange = "_dy-5";
export var colorPink = "_dy-a";
export var colorPurple = "_dy-9";
export var colorRed = "_dy-4";
export var colorYellow = "_dy-6";